<template lang='pug'>
vue-dropzone(
  :options='dropzoneOptions'
  @vdropzone-removed-file='onDelete'
  @vdropzone-success='onLoad'
  @vdropzone-error='onError'
  id='dropzone'
)
</template>

<script>
import http from '@/http'
import config from '@/config'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  components: {
    vueDropzone: vue2Dropzone
  },

  props: ['value'],

  data: () => ({
    hashes: {},
    dropzoneOptions: {
      url: config.baseURL + '/files/upload',
      thumbnailWidth: 150,
      maxFilesize: 10,
      addRemoveLinks: true,
      dictDefaultMessage: 'Нажмите или перенесите файлы сюда',
      dictRemoveFile: 'Удалить',
      dictCancelUpload: 'Отменить',
      paramName: 'attachFile'
    }
  }),

  methods: {
    async onDelete(file) {
      if (this.hashes[file.hash]) {
        try {
          await http.post('files/delete', { hash: file.hash })
          this.$delete(this.hashes, file.hash)
        } catch (error) {
          this.onError(file, error)
        }
      }
    },

    onLoad(file, response) {
      let { hash } = response.data

      file.hash = hash

      this.$set(this.hashes, [file.hash], file)
      this.$emit('input', this.hashes)
    },

    onError(file, error) {
      this.$emit('error', { file, error })
    }
  },

  watch: {
    value(val) {
      this.hashes = val
    }
  }
}
</script>

<style>
.vue-dropzone {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  border: solid 1px rgba(0, 0, 0, 0.12);
}
.vue-dropzone .dz-preview .dz-details {
  background-color: rgba(39, 174, 96, 0.8) !important;
}
.vue-dropzone .dz-preview.dz-error .dz-details {
  background-color: rgba(189, 22, 22, 0.8) !important;
}
.vue-dropzone .dz-preview .dz-remove {
  font-size: 10px;
  flex-wrap: 600;
  border-radius: 2px;
  padding-top: 6px;
  padding-bottom: 6px;
  border: solid 1px white;
  text-decoration: none !important;
}
.vue-dropzone .dz-preview.dz-image-preview {
  border: solid 1px rgba(0, 0, 0, 0.12);
}
.vue-dropzone .dz-preview.dz-image-preview:hover {
  border-color: transparent;
}
.vue-dropzone:hover {
  background: none;
}
.vue-dropzone.dropzone .dz-message {
  margin: 0 !important;
  font-weight: 500;
  font-size: 16px;
}
.vue-dropzone.dropzone {
  min-height: 80px;
}
</style>
